import { rotateAnimation, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const CloseButtonRow = styled.div`
  position: absolute;
  top: ${Spacing.S16};
  right: ${Spacing.S16};
`

interface IconWrapperProps {
  isLoading: boolean
}

export const IconWrapper = styled.figure<IconWrapperProps>`
  margin-right: ${Spacing.S4};
  font-size: 40px;

  > svg {
    width: 40px;
    height: 40px;
    ${({ isLoading }) => isLoading && rotateAnimation()};
  }
`
